import { colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function SystemCheck({
  width = 32,
  height = 32,
  fill = colors.grayscale200,
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.70012 28C5.96679 28 5.33923 27.7391 4.81745 27.2173C4.29479 26.6947 4.03345 26.0667 4.03345 25.3333V14.7333C3.52234 14.2667 3.12812 13.6667 2.85079 12.9333C2.57256 12.2 2.56679 11.4 2.83345 10.5333L4.23345 6C4.41123 5.42222 4.72812 4.94444 5.18412 4.56667C5.63923 4.18889 6.16679 4 6.76679 4H25.3001C25.9001 4 26.4223 4.18311 26.8668 4.54933C27.3112 4.91644 27.6335 5.4 27.8335 6L29.2335 10.5333C29.5001 11.4 29.4948 12.1889 29.2175 12.9C28.9392 13.6111 28.5446 14.2222 28.0335 14.7333V25.3333C28.0335 26.0667 27.7726 26.6947 27.2508 27.2173C26.7281 27.7391 26.1001 28 25.3668 28H6.70012ZM18.9668 13.3333C19.5668 13.3333 20.0223 13.1276 20.3335 12.716C20.6446 12.3053 20.7668 11.8444 20.7001 11.3333L19.9668 6.66667H17.3668V11.6C17.3668 12.0667 17.5223 12.4724 17.8335 12.8173C18.1446 13.1613 18.5223 13.3333 18.9668 13.3333ZM12.9668 13.3333C13.4779 13.3333 13.8948 13.1613 14.2175 12.8173C14.5392 12.4724 14.7001 12.0667 14.7001 11.6V6.66667H12.1001L11.3668 11.3333C11.2779 11.8667 11.3948 12.3333 11.7175 12.7333C12.0392 13.1333 12.4557 13.3333 12.9668 13.3333ZM7.03345 13.3333C7.43345 13.3333 7.78323 13.1889 8.08279 12.9C8.38323 12.6111 8.56679 12.2444 8.63345 11.8L9.36679 6.66667H6.76679L5.43345 11.1333C5.30012 11.5778 5.37212 12.0556 5.64945 12.5667C5.92768 13.0778 6.38901 13.3333 7.03345 13.3333ZM25.0335 13.3333C25.6779 13.3333 26.1446 13.0778 26.4335 12.5667C26.7223 12.0556 26.789 11.5778 26.6335 11.1333L25.2335 6.66667H22.7001L23.4335 11.8C23.5001 12.2444 23.6837 12.6111 23.9841 12.9C24.2837 13.1889 24.6335 13.3333 25.0335 13.3333Z"
        fill={fill}
      />
    </Svg>
  );
}
